import React from 'react';
import styled from 'styled-components';

const Container = styled.div<{ spotlight?: boolean }>`
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  pointer-events: ${({ spotlight }) => (spotlight ? 'none' : 'auto')};
  z-index: ${({ spotlight }) => (spotlight ? 21 : 'auto')};
`;

const Content = styled.div<{ spotlight?: boolean }>`
  width: 100%;
  max-width: 600px;
  background-color: var(--surface);
  color: var(--text);
  padding: 12px;
  box-shadow: ${({ spotlight }) =>
    spotlight ? '0 -10px 32px var(--spotlight-shadow)' : 'none'};
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Key = styled.div<{ letter: string; used: boolean }>`
  width: ${({ letter }) => (letter === '+' ? '55px' : '40px')};
  height: 40px;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--border-strong);
  border-radius: 10px;
  background-color: var(--surface);
  color: var(--text);
  cursor: pointer;
  user-select: none;
  :hover {
    background-color: var(--keyboard-hover);
  }

  ${({ used }) => used && 'background-color: var(--keyboard-used);'}
`;

const rows = ['qwertyuiop', 'asdfghjkl', '+zxcvbnm-'];

function Keyboard({
  expired,
  spotlight,
  usedLetters,
  onKeyPress,
}: {
  expired: boolean;
  spotlight?: boolean;
  usedLetters: string[];
  onKeyPress: (key: string) => void;
}) {
  if (expired) {
    return (
      <Container spotlight={spotlight}>
        <Content spotlight={spotlight}>No more guesses. Why have you done this to yourself?</Content>
      </Container>
    );
  } else {
    return (
      <Container spotlight={spotlight}>
        <Content spotlight={spotlight}>
          {rows.map((row) => (
            <Row key={row}>
              {row.split('').map((letter) => (
                <Key
                  key={letter}
                  letter={letter}
                  onClick={() => onKeyPress(letter)}
                  used={usedLetters.indexOf(letter) !== -1}
                >
                  {letter === '+' ? 'GO' : letter === '-' ? '⌫' : letter}
                </Key>
              ))}
            </Row>
          ))}
        </Content>
      </Container>
    );
  }
}

export default Keyboard;
